import confirm from "antd/lib/modal/confirm";
import { createContext, useState, useContext } from "react";
import { RiInformationLine } from "react-icons/ri";

const RoutesCofirmChangesContext = createContext(null);

export const RoutesCofirmChangesProvider = ({ children }) => {
  const [somethingChanged, setSomethingChanged] = useState(false);

  const showUnsaveConfirm = (handleConfirm) => {
    confirm({
      title: (
        <h5 className="hp-mb-0 hp-font-weight-500">
          {`If you leave this flow, your changes will not be saved. Are you sure you want to continue?`}
        </h5>
      ),
      icon: (
        <span className="remix-icon">
          <RiInformationLine color="red" />
        </span>
      ),
      okText: "Yes",
      onOk: async () => {
        try {
          await handleConfirm();
          setSomethingChanged(false);
        } catch (error) {
          console.error(error);
        }
      },
      onCancel() {
        return null;
      },
    });
  };

  return (
    <RoutesCofirmChangesContext.Provider
      value={{ somethingChanged, setSomethingChanged, showUnsaveConfirm }}
    >
      {children}
    </RoutesCofirmChangesContext.Provider>
  );
};

export const useRoutesSomethingChanged = () => {
  const context = useContext(RoutesCofirmChangesContext);

  return context;
};
